import { Grid, Button, FormControl, InputLabel, MenuItem, Typography, IconButton, Link } from "@material-ui/core";
import { FieldArray, Form, FormikProvider, useFormikContext } from "formik";
import { Observation } from "../../../types/referrals";
import i18nNamespaces from "../../../const/i18nNamespaces";
import { useTranslation } from "react-i18next";
import CustomSelect from "../../common/CustomSelect/CustomSelect";
import { SIDES } from "../../../const/referral";
import { ReferralFormValues } from "../../../pages/NewReferralPage/NewReferralPage";
import { Remove, RemoveCircleOutline, RemoveOutlined } from "@material-ui/icons";
import { useState } from "react";
import Icd10CodeAutocomplete from "../Icd10CodeAutocomplete/Icd10CodeAutocomplete";
import useStyles from '../../../pages/NewReferralPage/NewReferralPageStyles';
import clsx from "clsx";

type ObservationInputsProps = {
    formik: any;
}

const ObservationInputs = () => {
    const formik = useFormikContext<ReferralFormValues>();
    const {t} = useTranslation(i18nNamespaces.REFERRAL);
    const classes = useStyles();

    return (
        <FieldArray name="secondaryObservations">
            {({ push, remove }) => (
                <>
                    {formik.values.secondaryObservations && 
                    formik.values.secondaryObservations.map((obs: Observation, idx: number) => (
                        <Grid container item spacing={2} key={idx} className={classes.secondaryBlockContainer}>
                            <Grid item md={6} xs={12}>
                                <Icd10CodeAutocomplete
                                    label={t('secondaryObservation')}
                                    icd10Code={obs.icd10Code || null}
                                    onChange={newValue =>
                                        formik.setFieldValue(`secondaryObservations[${idx}].icd10Code`, newValue)
                                    }
                                    error={Array.isArray(formik.touched.secondaryObservations) && 
                                        Array.isArray(formik.errors.secondaryObservations) &&
                                        Boolean(formik.touched.secondaryObservations[idx]) && 
                                        Boolean(formik.errors.secondaryObservations && 
                                            formik.errors.secondaryObservations[idx])}
                                    helperText={
                                        Array.isArray(formik.touched.secondaryObservations) && 
                                        Array.isArray(formik.errors.secondaryObservations) && 
                                        formik.errors.secondaryObservations[idx]}
                                />
                            </Grid>
                            <Grid item md={5} xs={12}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel id={`secondaryObservations[${idx}].targetSite`}>
                                        {t('targetSite')}
                                    </InputLabel>
                                    <CustomSelect
                                        name={`secondaryObservations[${idx}].targetSite`}
                                        label={t('targetSite')}
                                        labelId={`secondaryObservations[${idx}].targetSite`}
                                        value={obs.targetSite || ''}
                                        onChange={formik.handleChange}
                                        fullWidth
                                        variant="outlined"
                                    >
                                        {Object.values(SIDES).map(side => (
                                            <MenuItem key={side} value={side}>
                                                {t('side.' + side)}
                                            </MenuItem>
                                        ))}
                                    </CustomSelect>
                                </FormControl>
                            </Grid>
                            <Grid item md={1} xs={12} className={classes.removeButtonContainer}>
                                <IconButton color="secondary" onClick={() => remove(idx)}>
                                    <RemoveCircleOutline fontSize="small"/>
                                </IconButton>
                            </Grid>
                        </Grid>
                    ))}
                    <Grid item xs={12}>
                        <Link color="secondary" className={classes.link} onClick={() => push({ icd10Code: null, targetSite: null })}>
                            {t('addObservation')}
                        </Link>
                    </Grid>
                </>
            )}
        </FieldArray>
    );
};

export default ObservationInputs;